import { dxtToLocalServerTime } from "@dexteel/mesf-core";

// Takes the raw string too, and that is the point: dxtToLocalServerTime only
// appends the "Z" when it gets a string. Wrapping an API timestamp in new Date()
// first makes the browser read that UTC value as local time, and the result comes
// out shifted by the browser's offset.
type DateTimeInput = Date | string | null | undefined;

export const ShortDateTimeFormat = (datetime: DateTimeInput) => {
	if (!datetime) return "";
	return dxtToLocalServerTime(datetime, "MM/dd/yy HH:mm");
};

export const shortestDateTime = (datetime: DateTimeInput) => {
	if (!datetime) return "";
	return dxtToLocalServerTime(datetime, "MMM dd HH:mm");
};
export const shDateTime = (datetime: DateTimeInput) => {
	if (!datetime) return "";
	return dxtToLocalServerTime(datetime, "MM/dd HH:mm");
};
